/** Webmail URL for “Open your email”. Unknown domains return null — hide the button. */

export function webmailUrlForEmail(email: string): string | null {
  const trimmed = email.trim().toLowerCase();
  const at = trimmed.lastIndexOf('@');
  if (at < 0) return null;
  const domain = trimmed.slice(at + 1);
  switch (domain) {
    case 'gmail.com':
    case 'googlemail.com':
      return 'https://mail.google.com';
    case 'outlook.com':
    case 'hotmail.com':
    case 'live.com':
    case 'msn.com':
      return 'https://outlook.live.com/mail';
    case 'yahoo.com':
    case 'ymail.com':
      return 'https://mail.yahoo.com';
    case 'proton.me':
    case 'protonmail.com':
      return 'https://mail.proton.me';
    default:
      return null;
  }
}
